// The order-confirmation template's presentation contract: keys a custom product may add to a child's `metadata.notifyLayout`.
// Section header printed in place of the child's tile (the unit's own Rig/Rack row, which the cart never lists either).
export const EMAIL_UNIT_KEY = 'Unit'
// Lists the child in the leading Rack section, ahead of every unit section, whatever its bundle-option position.
export const EMAIL_RACK_KEY = 'Rack'
// Header text printed before this child's tile; set on the first Rack child so the section title prints once.
export const EMAIL_SECTION_KEY = 'Section'
// Neither tile nor header: a config-carrier row the cart folds into the hero summary instead of listing (Slinger X Rack:/Functional Trainer:).
export const EMAIL_HIDDEN_KEY = 'Hidden'
